module.exports = __webpack_public_path__ + "img/dz.90da040a.png";